import { useUpdateAccount } from '../../../../hooks';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { EditModalRHF } from '../../Shared/EditModalRHF';

const { NAME, EDIT_SIGNING_SECRET, SIGNING_SECRET, API_KEY, EDIT_API_KEY } =
  ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TelnyxEditModal = () => {
  const { updateAccount } = useUpdateAccount();

  return (
    <EditModalRHF onSubmit={updateAccount}>
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      <ClearableConnectedInputField
        name={API_KEY}
        labelText="API key"
        wasEditedFieldName={EDIT_API_KEY}
        data-test="apiKey-input"
      />
      <ClearableConnectedInputField
        name={SIGNING_SECRET}
        labelText="Signing secret"
        wasEditedFieldName={EDIT_SIGNING_SECRET}
        data-test="signingSecret-input"
      />
    </EditModalRHF>
  );
};
